import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface UserUpdate {
  firstName: string;
  lastName: string;
  phone: string;
}

const UpdateUserProfile = () => {
  const [userupdate, setUserupdate] = useState<UserUpdate>({
    firstName: "",
    lastName: "",
    phone: "",
  });

  const navigate = useNavigate()

  const token = localStorage.getItem("accessToken");
  const userId: any = localStorage.getItem("id");

  console.log("------------", userId);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setUserupdate({ ...userupdate, [e.target.name]: e.target.value });
    console.log("user input update", userupdate);
  };

  const handlesave = async (e: any) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.React_App_DYO_CHEF_UserInfo_URL}${userId}`,
        {
          method: "PUT",
          body: JSON.stringify(userupdate),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("user update success");
        navigate('/userprofile')
      }else if(response.status === 401){
          console.log("Authentication");
          navigate('/userprofile')
      }
    } catch (error) {
      console.log("API IS WRONG");
      navigate('/userprofile ')
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm profile-image-items text-center">
            <img
              src="https://pub-3009e77e37704c5da613b25a085bcd33.r2.dev/dyo-profile.png"
              className="img-fluid rounded-circle"
              alt="user profile"
            />
          </div>

          <div className="col-sm rounded">
            <form className="">
              <div className="mb-3 mt-5">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  First name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  name="firstName"
                  value={userupdate.firstName}
                  onChange={handleChange}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Last name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  name="lastName"
                  value={userupdate.lastName}
                  onChange={handleChange}
                  placeholder="Enter Last Name"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Phone
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  name="phone"
                  value={userupdate.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                />
              </div>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button
                  className="btn btn-primary me-md-3 pe-5 ps-5 rounded-pill"
                  type="button"
                  onClick={handlesave}
                >
                  Save
                </button>
                <Link
                  className="btn btn-primary pe-5 ps-5 rounded-pill"
                  type="button" to="/userprofile" >
                  Back
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateUserProfile;
